import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  removeAll as removeAllUsers,
  addArray as addUsersArray
} from 'store/redux/spUsers'

export default function * fetchSPUsers (action) {
  const { keyword } = action.payload

  if (!keyword) {
    yield put([
      removeAllUsers(),
      setLoadStatus({
        loading: false,
        loaded: true
      })
    ])

    return
  }

  yield put([
    removeAllUsers(),
    setLoadStatus({
      loading: true,
      loaded: false
    })
  ])

  const args = {}

  if (keyword) args.query = keyword

  try {
    const Users = yield call(apiGetData, 'SearchUserByPicker', args)

    yield put([
      addUsersArray(Users.map(User => ({
        profileKey: User.Key,
        name: User.Name,
        logins: User.Logins.map(Login => ({
          type: Login.Type,
          name: Login.Name,
        }))
      }))),
      setLoadStatus({
        loading: false,
        loaded: true
      })
    ])
  } catch (error) {
    yield put(setLoadStatus({
      loading: false,
      loaded: false
    }))

    throw error
  }
}
